import React, { Component } from "react";
import { Toast } from '../Notification';
import moment from 'moment';
import _ from 'underscore';
import DayTypeRequestsCalendarGeneralForm from './DayTypeRequestsCalendarGeneralForm';
import blankDayTypeRequest from './utils/day-type-requests/blankDayTypeRequest';
import dayTypesArray from './utils/day-type-requests/dayTypes';
import statusArray from './utils/day-type-requests/status';
import * as dayTypeActions from '../../redux/actions/dayTypeActions';
import * as resourceActions from '../../redux/actions/resourceActions';
import * as tourActions from '../../redux/actions/tourActions';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';

const lodash = require('lodash');
const timezone = 'UTC'; //Should be set to the timezone of the server, since amplify is on the cloud it uses UTC

class DayTypeRequestsCalendarUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contextMenuKey: this.props.contextMenuKey || false,
      selectedDayTypeRequest: this.props.selectedDayTypeRequest,
      selectedDates: this.props.selectedDates,
      resource: this.props.selectedDayTypeResource,
      dayTypesDayRule: [],
    }
  }

  componentDidMount() {
    this.checkResource();
  }

  componentWillReceiveProps({ contextMenuKey, selectedDayTypeRequest, selectedDates }) {
    this.setState({
      contextMenuKey,
      selectedDayTypeRequest,
      selectedDates
    });
  }

  checkResource = () => {
    let resource;
    if (!this.state.resource.id && !this.state.resource.name) {
      resource = {
        id: this.props.user.login.resourceId,
        name: this.props.user.userDemographics.name
      }
      this.setState({
        resource
      }, () => {
        this.getDayTypesByDayRule();
      });
    } else {
      this.getDayTypesByDayRule();
    }
  }

  clearForm = () => {
    this.setState({
      selectedDayTypeRequest: { ...blankDayTypeRequest }
    })
  }

  handleDayTypeChange = (value, callback) => {
    const { selectedDayTypeRequest } = this.state;
    selectedDayTypeRequest.dayTypeId = value;

    this.setState({
      selectedDayTypeRequest
    }, () => { callback() });
  }

  handleFromDateChange = (value, callback) => {
    const { selectedDayTypeRequest } = this.state;
    selectedDayTypeRequest.fromDate = value;

    this.setState({
      selectedDayTypeRequest
    }, () => { callback() });
  }

  handleToDateChange = (value, callback) => {
    const { selectedDayTypeRequest } = this.state;
    selectedDayTypeRequest.toDate = value;

    this.setState({
      selectedDayTypeRequest
    }, () => { callback() });
  }

  handleFromTimeChange = (value, callback) => {
    const { selectedDayTypeRequest } = this.state;
    selectedDayTypeRequest.fromTime = value;

    this.setState({
      selectedDayTypeRequest
    }, () => { callback() });
  }

  handleToTimeChange = (value, callback) => {
    const { selectedDayTypeRequest } = this.state;
    selectedDayTypeRequest.toTime = value;

    this.setState({
      selectedDayTypeRequest
    }, () => { callback() });
  }

  handleStatusChange = (value, callback) => {
    const { selectedDayTypeRequest } = this.state;
    selectedDayTypeRequest.status = value;

    this.setState({
      selectedDayTypeRequest
    }, () => { callback() });
  }

  handleMyCommentChange = (value, callback) => {
    const { selectedDayTypeRequest } = this.state;
    selectedDayTypeRequest.myComment = value.target.value.replace(/[^a-zA-Z0-9,:;\-.!@?#%|/$()& \n]/g,'');

    this.setState({
      selectedDayTypeRequest
    }, () => { callback() });
  }

  handleStatusCommentChange = (value, callback) => {
    const { selectedDayTypeRequest } = this.state;
    selectedDayTypeRequest.statusComment = value.target.value.replace(/[^a-zA-Z0-9,:;\-.!@?#%|/$()& \n]/g,'');

    this.setState({
      selectedDayTypeRequest
    }, () => { callback() });
  }

  checkIfTourInDateRange = async (params) => {
    let parameters = {
      resourceId: this.state.liveResource && this.state.liveResource.id ? this.state.liveResource.id : this.state.resource.id,
      fromDate: params.fromDate.startOf('day').format('DD MMM YYYY HH:mm:ss ') + timezone,
      toDate: params.toDate.startOf('day').format('DD MMM YYYY HH:mm:ss ') + timezone
    }

    await this.props.actions.fetchIfToursAreInDateRange(parameters);

    return this.props.ifToursAreInDateRange;
  }

  checkIfHasHolidaySchedule = async (params) => {

    let foundDayType = this.state.dayTypesDayRule.find(dayType => dayType.dayTypeId === params.dayType);
    let p = {
      dayTypeId: foundDayType.dayTypeId,
      resourceId: this.state.liveResource && this.state.liveResource.id ? this.state.liveResource.id : this.state.resource.id,
      fromDate: params.fromDate.startOf('day').format('YYYY-MM-DD'),
      toDate: params.toDate.startOf('day').format('YYYY-MM-DD'),
      status: params.status
    }

    await this.props.actions.fetchIfHasHolidaySchedule(p);

    return this.props.ifHasHolidaySchedule.hasHolidaySchedule;
  }

  createDayTypeRequest = async (formValues) => {
    this.props.handleModalCancel();

    //find the day type id and status value for the request
    let foundDayType;
    if(this.props.dayTypesByDayRule && this.props.dayTypesByDayRule.length > 0){
      foundDayType = this.props.dayTypesByDayRule.find(dayType => dayType.dayTypeId === formValues.dayType);
    } else {
      foundDayType = this.props.dayTypesAll.find(dayType => dayType.dayTypeId === formValues.dayType);
    }

    let foundStatus = statusArray.find(status => status.value === formValues.status)

    if(!foundStatus){ // checks to make sure the form gave us a value, if it didn't we need to give it a default
      if(!foundDayType.approvalNeeded){
        foundStatus = statusArray.find(status => status.value === "A");
      }
    }
    
    foundStatus = foundStatus || {}
    
    //add the from and to times to their date counterparts
    let formattedFromDate = formValues.fromDate.startOf('day').format('DD MMM YYYY HH:mm:ss ') + timezone;
    let formattedFromTime;
    if (moment.isMoment(formValues.fromTime)) {
      formattedFromTime = formValues.fromTime.format('DD MMM YYYY HH:mm:ss ') + timezone;
    }

    let formattedToDate = formValues.toDate.startOf('day').format('DD MMM YYYY HH:mm:ss ') + timezone;
    let formattedtoTime;
    if (moment.isMoment(formValues.toTime)) {
      formattedtoTime = formValues.toTime.format('DD MMM YYYY HH:mm:ss ') + timezone;
    }

    const parameters = {
      resourceId: this.state.liveResource && this.state.liveResource.id ? this.state.liveResource.id : this.state.resource.id,
      dayTypeId: foundDayType.dayTypeId,
      requestDate: moment().format('DD MMM YYYY HH:mm:ss ') + timezone,
      fromDate: formattedFromDate,
      toDate: formattedToDate,
      fromTime: formattedFromTime ? formattedFromTime : null,
      toTime: formattedtoTime ? formattedtoTime : null,
      remark: formValues.myComment || '',
      status: foundStatus.value ? foundStatus.value : 'U',
      statusRemark: formValues.statusComment || '',
      comment: '',
      userId: this.props.user.login.id
    };

    let notification = { type: 'success', message: 'Day Type Request Added' };

    try {
      await this.props.actions.addDayType(parameters);
    }
    catch (error) {
      if (!_.isEmpty(error)) {
        notification = {
          type: 'error',
          message: "Adding Day Type Request Failed",
          description: error.errors[0].message.includes('->') ? error.errors[0].message.split('->')[1] : error.errors[0].message
        };
      }
    }
    Toast(notification);
    if (notification.type !== 'error') {
      this.clearForm();
      this.props.readyApiCall();
    }
  }

  createMultipleDayTypeRequests = async (formValues) => {
    this.props.handleModalCancel();

    //find the day type id and status value for the request
    let foundDayType;
    if(this.props.dayTypesByDayRule && this.props.dayTypesByDayRule.length && this.props.dayTypesByDayRule.length > 0){
      foundDayType = this.props.dayTypesByDayRule.find(dayType => dayType.dayTypeId === formValues.dayType);
    } else {
      foundDayType = this.props.dayTypesAll.find(dayType => dayType.dayTypeId === formValues.dayType);
    }
    
    let foundStatus = statusArray.find(status => status.value === formValues.status)

    if (!foundStatus) { // checks to make sure the form gave us a value, if it didn't we need to give it a default
      if (!foundDayType.approvalNeeded) {
        foundStatus = statusArray.find(status => status.value === "A");
      } 
    }
    foundStatus = foundStatus || {}

    this.state.selectedDates.forEach(async (event, index) => {
      //add the from and to times to their date counterparts
      let formattedFromDate = moment(event.start).startOf('day').format('DD MMM YYYY HH:mm:ss ') + timezone;
      let formattedToDate = moment(event.end).startOf('day').format('DD MMM YYYY HH:mm:ss ') + timezone;

      const parameters = {
        resourceId: this.state.liveResource && this.state.liveResource.id ? this.state.liveResource.id : this.state.resource.id,
        dayTypeId: foundDayType.dayTypeId,
        requestDate: moment().format('DD MMM YYYY HH:mm:ss ') + timezone,
        fromDate: formattedFromDate,
        toDate: formattedToDate,
        fromTime: null,
        toTime: null,
        remark: formValues.myComment || '',
        status: foundStatus.value ? foundStatus.value : "U",
        statusRemark: formValues.statusComment || '',
        comment: '',
        userId: this.props.user.login.id
      };

      let notification = { type: 'success', message: 'Day Type Request Added' };

      try {
        await this.props.actions.addDayType(parameters);
      }
      catch (error) {
        if (!_.isEmpty(error)) {
          notification = {
            type: 'error',
            message: "Adding Day Type Request Failed",
            description: error.errors[0].message.includes('->') ? error.errors[0].message.split('->')[1] : error.errors[0].message
          };
        }
      }
      Toast(notification);
      if (notification.type !== 'error') {
        this.clearForm();
        if (index === this.state.selectedDates.length - 1) {
          this.props.readyApiCall();
        }
      }
    });
  }

  updateDayTypeRequest = async (formValues, dayTypeRequestId) => {
    this.props.handleModalCancel();

    //find the day type id and status value for the request
    let foundDayType;
    if (this.props.dayTypesByDayRule && this.props.dayTypesByDayRule.length && this.props.dayTypesByDayRule.length > 0) {
      foundDayType = lodash.cloneDeep(this.props.dayTypesByDayRule.find(dayType => dayType.dayTypeName === formValues.dayType));
      foundDayType.id = foundDayType.dayTypeId;

    } else {
      // foundDayType = dayTypesArray.find(dayType => dayType.dayTypeName === formValues.dayType);
      foundDayType = lodash.cloneDeep(this.props.dayTypesAll.find(dayType => dayType.dayTypeName === formValues.dayType));
      foundDayType.id = foundDayType.dayTypeId;
    }

    let foundStatus = statusArray.find(status => status.name === formValues.status)

    if (!foundStatus) { // checks to make sure the form gave us a value, if it didn't we need to give it a default
      if (foundDayType.approvalNeeded) {
        foundStatus = statusArray.find(status => status.name === "Unapproved");
      } else {
        foundStatus = statusArray.find(status => status.name === "Approved");
      }
    }

    //add the from and to times to their date counterparts
    let formattedFromDate = formValues.fromDate.startOf('day').format('DD MMM YYYY HH:mm:ss ') + timezone;
    let formattedFromTime;
    if (moment.isMoment(formValues.fromTime)) {
      formattedFromTime = formValues.fromTime.format('DD MMM YYYY HH:mm:ss ') + timezone;
    }

    let formattedToDate = formValues.toDate.startOf('day').format('DD MMM YYYY HH:mm:ss ') + timezone;
    let formattedtoTime;
    if (moment.isMoment(formValues.toTime)) {
      formattedtoTime = formValues.toTime.format('DD MMM YYYY HH:mm:ss ') + timezone;
    }

    const parameters = {
      resourceId: this.state.resource.id,
      dayTypeId: foundDayType.id,
      requestDate: moment().format('DD MMM YYYY HH:mm:ss ') + timezone,
      fromDate: formattedFromDate,
      toDate: formattedToDate,
      fromTime: formattedFromTime ? formattedFromTime : null,
      toTime: formattedtoTime ? formattedtoTime : null,
      remark: formValues.myComment || '',
      status: foundStatus.valu ? foundStatus.value : 'U',
      statusRemark: formValues.statusComment || '',
      comment: '',
      userId: this.props.user.login.id,
      id: dayTypeRequestId
    };

    let notification = { type: 'success', message: 'Day Type Request Updated' };

    try {
      await this.props.actions.editDayType(parameters);
    }
    catch (error) {
      if (!_.isEmpty(error)) {
        notification = {
          type: 'error',
          message: "Updating Day Type Request Failed",
          description: error.errors[0].message.includes('->') ? error.errors[0].message.split('->')[1] : error.errors[0].message
        };
      }
    }
    Toast(notification);
    if (notification.type !== 'error') {
      this.clearForm();
      this.props.readyApiCall();
    }
  }

  deleteDayTypeRequest = async (dayTypeRequestId) => {
    this.props.handleModalCancel();

    let notification = { type: 'success', message: 'Day Type Request Removed' };

    let parameters = { dayTypeRequestId };

    try {
      await this.props.actions.removeDayType(parameters);
    }
    catch (error) {
      if (!_.isEmpty(error)) {
        notification = {
          type: 'error',
          message: "Removing Day Type Request Failed",
          description: error.errors[0].message.includes('->') ? error.errors[0].message.split('->')[1] : error.errors[0].message
        };
      }
    }
    Toast(notification);
    if (notification.type !== 'error') {
      this.clearForm();
      this.props.readyApiCall();
    }
  }

  getDayTypesByDayRule = async () => {

    let resourceId = this.state.liveResource && this.state.liveResource.id ? this.state.liveResource.id : this.state.resource.id;
    let userId = this.props.user.login.id

    if (typeof resourceId === 'string') {
      resourceId = parseInt(resourceId);
    }

    const params = {
      resourceId: resourceId,
      userId: userId
    };

    await this.props.actions.fetchDayTypesByDayRule(params);

    this.setState({
      dayTypesDayRule: this.props.dayTypesByDayRule
    });
  }

  getStatedDayTypesByDayRule = () =>{
    return this.state.dayTypesDayRule;
  }
  getStatedDayTypesAll = () => {
    return this.state.dayTypesAll;
  }

  render() {
    return (
      <DayTypeRequestsCalendarGeneralForm
        user={this.props.user}
        resource={this.state.resource}
        dayTypeRequestDetails={this.state.selectedDayTypeRequest}
        contextMenuKey={this.state.contextMenuKey}
        selectedDates={this.state.selectedDates}
        dayTypesAll={this.props.dayTypesAll}
        dayTypesDayRule={this.state.dayTypesDayRule}
        getDayTypesByDayRule={this.getDayTypesByDayRule}
        createDayTypeRequest={this.createDayTypeRequest}
        createMultipleDayTypeRequests={this.createMultipleDayTypeRequests}
        updateDayTypeRequest={this.updateDayTypeRequest}
        deleteDayTypeRequest={this.deleteDayTypeRequest}
        checkIfTourInDateRange={this.checkIfTourInDateRange}
        handleDayTypeChange={this.handleDayTypeChange}
        handleFromDateChange={this.handleFromDateChange}
        handleToDateChange={this.handleToDateChange}
        handleFromTimeChange={this.handleFromTimeChange}
        handleToTimeChange={this.handleToTimeChange}
        handleStatusChange={this.handleStatusChange}
        handleMyCommentChange={this.handleMyCommentChange}
        handleStatusCommentChange={this.handleStatusCommentChange}
        checkIfHasHolidaySchedule ={this.checkIfHasHolidaySchedule}
        getDayTypesByDayRule = {this.getStatedDayTypesByDayRule}
        getDayTypesAll = {this.getStatedDayTypesAll}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    resources: state.resources,
    selectedDayTypeResource: state.selectedDayTypeResource,
    dayTypeRequests: state.dayTypeRequestsByYear,
    dayTypesAll: state.dayTypesAll.dayTypes,
    dayTypesByDayRule: state.dayTypesByDayRule.dayTypes,
    ifToursAreInDateRange: state.ifToursAreInDateRange.data[0],
    ifHasHolidaySchedule: state.ifHasHolidaySchedule
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchDayTypeRequestsByYear: bindActionCreators(
        dayTypeActions.fetchDayTypeRequestsByYear,
        dispatch
      ),
      fetchDayTypesByDayRule: bindActionCreators(
        dayTypeActions.fetchDayTypesByDayRule,
        dispatch
      ),
      fetchIfToursAreInDateRange: bindActionCreators(
        tourActions.fetchIfToursAreInDateRange,
        dispatch
      ),
      addDayType: bindActionCreators(
        dayTypeActions.createDayType,
        dispatch
      ),
      editDayType: bindActionCreators(
        dayTypeActions.editDayType,
        dispatch
      ),
      removeDayType: bindActionCreators(
        dayTypeActions.removeDayType,
        dispatch
      ),
      updateSelectedDayTypeResource: bindActionCreators(
        resourceActions.updateSelectedDayTypeResource,
        dispatch
      ),
      fetchIfHasHolidaySchedule: bindActionCreators(
        dayTypeActions.fetchIfHasHolidaySchedule,
        dispatch
      )
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DayTypeRequestsCalendarUpdate);



// WEBPACK FOOTER //
// ./src/Components/DayType/DayTypeRequestsCalendarUpdate.js